import { CommonContext } from '@repo-level/core-front';
import type { CMSLicenseText } from 'api/cms/base';
import { useContext } from 'react';
import { ANJOUAN_COUNTRIES } from '../constants';

export const usePoliciesByCountryCode = (data: CMSLicenseText | undefined) => {
  const { currentIp } = useContext(CommonContext);

  if (!data) return '';

  if (
    currentIp?.countryCode &&
    ANJOUAN_COUNTRIES.includes(currentIp.countryCode)
  )
    return data.textAnjouan;

  return data.textTabique;
};
